var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "site-rich-text-wrapper" },
    [
      _vm.disabled && _vm.value
        ? [
            _c("div", {
              staticClass: "rich-text-preview",
              domProps: { innerHTML: _vm._s(_vm.value) },
            }),
          ]
        : [
            _c("site_rich_text", {
              ref: "rich",
              attrs: {
                id: _vm.editorId,
                value: _vm.currentValue,
                toolbars: _vm.toolbars,
                height: _vm.height,
                width: "100%",
              },
              on: { change: _vm.onChange, input: _vm.onChange },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }